import RawEndpoint from '@/app/base/endpoints/RawEndpoint';
import { JsonRequestPayload } from '@/app/base/endpoints/types';

export type EmailValidationReason = 'invalid_format' | 'invalid_domain' | 'spoof_detected';

export interface ValidatedEmailResponse {
    valid: boolean;
    reason: EmailValidationReason | null;
}

export default class ValidateEmailEndpoint extends RawEndpoint {
    path: string = 'common/email';

    async validate(email: string): Promise<ValidatedEmailResponse> {
        const payload: JsonRequestPayload = {
            method: 'POST',
            path: '-actions/validate',
            data: { email },
        };

        const response = await this.requestRaw(payload);

        if (!response.ok) {
            throw new Error(`Email validation endpoint returned ${response.status}`);
        }

        return (await response.json()) as ValidatedEmailResponse;
    }
}
